var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #43b02a;\r\n      }\r\n\r\n      .cls-1 {\r\n        opacity: 0.2;\r\n      }\r\n\r\n      .cls-2 {\r\n        opacity: 0.8;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12762",
    "data-name": "Group 12762",
    transform: "translate(-610 -217)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2526",
    "data-name": "Ellipse 2526",
    className: "cls-1",
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    transform: "translate(610 217)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2525",
    "data-name": "Ellipse 2525",
    className: "cls-2",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(616 223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    className: "cls-3",
    d: "M63.16,80.259,40.12,103.3l-8.466-8.466a1.051,1.051,0,0,0-1.487,0L27.69,97.311a1.051,1.051,0,0,0,0,1.486l11.686,11.686a1.051,1.051,0,0,0,1.487,0L67.124,84.223a1.051,1.051,0,0,0,0-1.487l-2.477-2.477A1.051,1.051,0,0,0,63.16,80.259Z",
    transform: "translate(608.117 166.727)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.2d0a7830ca5228c926c50d2cbc5ad42c.svg";
export { ForwardRef as ReactComponent };